import { Download, Search } from "lucide-react";
import * as React from "react";
import ExportButton from "./useExcelExport";

export default function ExpanseFilterSection({
  searchTerm,
  setSearchTerm,
  filterBySearchTerm,
}) {
  const [selectedPeriod, setSelectedPeriod] = React.useState("month");

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 flex items-between">
      <div className="relative">
        <Search className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
        <input
          type="text"
          placeholder="Expenses, Category, Description"
          className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#127971] focus:border-transparent"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* <div className="flex gap-2">
        <select
          className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#127971] focus:border-transparent"
          value={selectedPeriod}
          onChange={(e) => setSelectedPeriod(e.target.value)}
        >
          <option value="day">Daily</option>
          <option value="week">Weekly</option>
          <option value="month">Monthly</option>
          <option value="year">Yearly</option>
        </select>
      </div> */}

      <ExportButton
        data={filterBySearchTerm}
        selectedPeriod={selectedPeriod}
        icon={<Download className="w-5 h-5" />}
      />
    </div>
  );
}
